
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Seatertempo() {



    const cardData =
    {
        keyword: '25 Seater Tempo Traveller on Rent in Pune',
        heading: 'Amruta Travels: 25 Seater Tempo Traveller on Rent in Pune',
        headingDescription: 'Amruta Travels offers 25 Seater Tempo Traveller on Rent in Pune, ensuring a spacious, comfortable, and hassle-free journey for groups. Whether you are planning a family trip, corporate outing, or special occasion, our well-maintained 25-seater Tempo Travellers provide a smooth and enjoyable ride. Enjoy on-time service, professional drivers, affordable rates, and 24/7 availability for your travel needs. Book your 25 Seater Tempo Traveller with Amruta Travels and experience group travel with maximum comfort and convenience!',


        top: 'Top Places to Visit in Pune with Amruta Travels',

        "topPlaces": [
            {
                "title": "Shaniwar Wada",
                "description": "Built in 1732 by the Peshwas of the Maratha Empire, Shaniwar Wada is a historic fort in central Pune. Known for its massive Delhi Gate, beautiful gardens, and tales of royal intrigue, it's a major attraction. Don't miss the evening light and sound show that narrates its rich past."
            },
            {
                "title": "Aga Khan Palace",
                "description": "An architectural gem and a symbol of India’s freedom struggle, the Aga Khan Palace was built in 1892. It once housed Mahatma Gandhi and his wife Kasturba. Today, it features a museum with personal artifacts, peaceful gardens, and memorials."
            },
            {
                "title": "Sinhagad Fort",
                "description": "This hilltop fort, located 35 km from Pune, is famous for its historic Battle of Sinhagad and stunning views. A popular trekking destination, it offers visitors a mix of adventure, history, and local Maharashtrian snacks like pithla-bhakri."
            },
            {
                "title": "Osho Ashram",
                "description": "Nestled in the lush greenery of Koregaon Park, Osho International Meditation Resort is a spiritual retreat offering meditation, wellness workshops, and mindfulness programs. It attracts global visitors looking for peace and transformation."
            },
            {
                "title": "Pataleshwar Cave Temple",
                "description": "Dating back to the 8th century, this rock-cut temple dedicated to Lord Shiva is carved from a single basalt rock. Located in the heart of Pune, it’s a peaceful oasis amidst the city bustle with detailed stone carvings and spiritual ambiance."
            },
            {
                "title": "Raja Dinkar Kelkar Museum",
                "description": "This one-of-a-kind museum showcases over 20,000 artifacts including musical instruments, weapons, sculptures, and art pieces. It’s a window into India’s rich cultural history, curated lovingly by Dr. Dinkar Kelkar in memory of his son."
            },
            {
                "title": "Khadakwasla Dam",
                "description": "A popular weekend spot just outside Pune, Khadakwasla Dam is perfect for a scenic drive, evening stroll, or picnic. The serene waters, cool breeze, and roadside food vendors make it a relaxing escape from the city."
            },
            {
                "title": "Fergusson College Road",
                "description": "A youthful and energetic area filled with cafes, eateries, and shopping outlets, Fergusson College Road is a go-to spot for college students and tourists alike. From fashion finds to tasty street food, it offers a lively Pune experience."
            },
            {
                "title": "Lal Mahal",
                "description": "Originally built in the 1630s by Shahaji Bhosale, Lal Mahal is linked to the childhood of Chhatrapati Shivaji Maharaj. The reconstructed palace features exhibits and murals depicting the Maratha warrior’s early life and battles."
            },
            {
                "title": "Pune-Okayama Friendship Garden",
                "description": "Inspired by Japan’s Korakuen Garden, this beautifully landscaped park features flowing streams, stone bridges, koi ponds, and walking paths. It's a serene and photogenic spot ideal for families and couples."
            }
        ],

          "services": [
    {
      "name": "Tempo Traveller 25 Seater Rent Per KM in Pune",
      "description": "Looking for a 25-seater Tempo Traveller in Pune at a per-kilometer rate? Amruta Travels offers flexible pricing and high-quality service for both local and outstation travel. Ideal for groups, corporate teams, and family trips, our Tempo Travellers are spacious, reliable, and cost-effective."
    },
    {
      "name": "Tempo Traveller 25 Seater AC Bus on Rent Pune",
      "description": "Enjoy air-conditioned comfort with Amruta Travels’ 25-seater Tempo Traveller AC bus rental in Pune. Perfect for summer trips, events, and long-distance journeys, our vehicles are equipped with comfortable seating, ample luggage space, and experienced drivers to ensure a hassle-free ride."
    },
    {
      "name": "Tempo Traveller 26 Seater Non-AC Bus on Rent in Pune",
      "description": "Amruta Travels offers budget-friendly 26-seater non-AC Tempo Travellers in Pune. Suitable for school trips, large family outings, and economical travel needs, our non-AC vehicles are well-maintained and perfect for short to mid-range travel."
    },
    {
      "name": "26 Bus on Rent for Wedding in Pune",
      "description": "Planning a wedding in Pune? Hire a 26-seater bus from Amruta Travels to conveniently transport guests between venues. Our wedding transportation service ensures timely pick-ups, comfortable seating, and smooth coordination for your big day."
    },
    {
      "name": "25 Bus on Rent Pimpri Chinchwad Pune",
      "description": "Amruta Travels provides 25-seater buses for rent in Pimpri Chinchwad, ideal for corporate, school, or personal travel. Our buses come with trained drivers and are perfect for navigating city routes or heading outstation from PCMC."
    },
    {
      "name": "25 Bus on Rent in Pune for Picnics",
      "description": "Make your group picnic plans stress-free with Amruta Travels’ 25-seater bus rentals in Pune. Whether it’s a family picnic or a school outing, we provide clean, comfortable, and safe buses for a fun-filled trip."
    },
    {
      "name": "Pune to Goa 25 Seater Bus Fare",
      "description": "Planning a group trip from Pune to Goa? Book Amruta Travels’ 25-seater bus at competitive fare rates. Enjoy scenic travel with comfortable seating, AC options, and courteous drivers. Contact us for per km rates and package deals."
    },
    {
      "name": "26 Seater Tempo Traveller on Rent in Pune",
      "description": "Amruta Travels offers 26-seater Tempo Travellers on rent in Pune for weddings, events, outstation tours, and corporate travel. Our spacious vehicles are ideal for large group travel with professional drivers ensuring a safe journey."
    },
    {
      "name": "25 Seater Bus on Rent in Hadapsar Pune",
      "description": "Looking for a 25-seater bus rental in Hadapsar? Amruta Travels has you covered with convenient pickup and drop service, perfect for corporate transport, events, and local sightseeing from Pune’s eastern corridor."
    },
    {
      "name": "Pune to Shirdi 25 Seater Bus on Rent",
      "description": "Book a comfortable and devotional group journey with Amruta Travels’ 25-seater bus from Pune to Shirdi. We offer AC and non-AC options, reliable service, and professional drivers for a peaceful darshan experience."
    },
    {
      "name": "Pune Airport to Shirdi 25-Seater Tempo Traveller on Rent",
      "description": "Arriving at Pune Airport and heading to Shirdi? Amruta Travels offers direct 25-seater Tempo Traveller rentals for airport transfers. Enjoy a comfortable and convenient ride to Shirdi with luggage space and onboard seating comfort."
    },
    {
      "name": "Pune to Bhimashankar 25 Seater Tempo Traveller",
      "description": "Plan your spiritual getaway to Bhimashankar with Amruta Travels’ 25-seater Tempo Traveller. We provide safe and smooth transportation, ideal for family or group pilgrimages from Pune to one of Maharashtra’s revered Jyotirlinga sites."
    },
    {
      "name": "Pune to 5 Jyotirlinga Darshan Tempo Traveller on Rent",
      "description": "Visit the sacred 5 Jyotirlinga temples with ease by renting a Tempo Traveller from Amruta Travels. Our 25-seater vehicles offer ample space, AC comfort, and experienced drivers to make your multi-day pilgrimage spiritually uplifting and logistically smooth."
    }
  ],

  "tableData": [
    ["Tempo Traveller 25 Seater Rent Per KM in Pune", "Tempo Traveller 25 Seater AC Bus on Rent Pune"],
    ["Tempo Traveller 26 Seater Non-AC Bus on Rent in Pune", "26 Bus on Rent for Wedding in Pune"],
    ["25 Bus on Rent Pimpri Chinchwad Pune", "25 Bus on Rent in Pune for Picnics"],
    ["Pune to Goa 25 Seater Bus Fare", "26 Seater Tempo Traveller on Rent in Pune"],
    ["25 Seater Bus on Rent in Hadapsar Pune", "Pune to Shirdi 25 Seater Bus on Rent"],
    ["Pune Airport to Shirdi 25-Seater Tempo Traveller on Rent", "Pune to Bhimashankar 25 Seater Tempo Traveller"],
    ["Pune to 5 Jyotirlinga Darshan Tempo Traveller on Rent", ""]
  ],





    "whychoose": [
  {
    "WhyChooseheading": "Spacious and Comfortable Travel for Groups",
    "WhyChoosedescription": "Amruta Travels offers 25 Seater Tempo Traveller on Rent in Pune, ideal for group travel with family, friends, or colleagues. Enjoy spacious interiors, comfortable seating, and air conditioning for a smooth and enjoyable journey."
  },
  {
    "WhyChooseheading": "Perfect for All Types of Trips",
    "WhyChoosedescription": "Whether it’s a wedding, corporate outing, pilgrimage, or picnic, our 25 Seater Tempo Traveller rental service in Pune is suited for all kinds of group events. We ensure a convenient and reliable travel experience every time."
  },
  {
    "WhyChooseheading": "Experienced and Courteous Drivers",
    "WhyChoosedescription": "Our Tempo Travellers come with experienced, well-trained drivers who are familiar with Pune and surrounding routes. They prioritize safety, punctuality, and a smooth ride for all passengers."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "Amruta Travels offers competitive rates for 25 Seater Tempo Traveller on Rent in Pune. We maintain complete transparency with no hidden fees—only clear, upfront pricing for your convenience."
  },
  {
    "WhyChooseheading": "Clean, Well-Maintained Vehicles",
    "WhyChoosedescription": "Our Tempo Travellers are regularly cleaned, serviced, and maintained to provide a reliable and hygienic travel experience. Enjoy peace of mind with vehicles that meet high standards of quality and safety."
  },
  {
    "WhyChooseheading": "Flexible Booking and 24/7 Availability",
    "WhyChoosedescription": "We understand that plans can change. That’s why Amruta Travels offers flexible booking options and round-the-clock availability for our 25 Seater Tempo Traveller rental in Pune—perfect for early morning or late-night departures."
  },
  {
    "WhyChooseheading": "Custom Travel Plans to Fit Your Itinerary",
    "WhyChoosedescription": "Need specific pick-up points, stopovers, or a custom route? We provide tailored travel plans to match your schedule and preferences, making your group journey smooth and stress-free."
  },
  {
    "WhyChooseheading": "Easy and Hassle-Free Booking Process",
    "WhyChoosedescription": "Booking a 25 Seater Tempo Traveller with Amruta Travels is simple. You can reserve your vehicle online, through a phone call, or by visiting our office. We make the process fast, clear, and customer-friendly."
  }
]





















    }

const faqData = [
  {
    question: 'How can I rent a 25 seater Tempo Traveller in Pune with Amruta Travels?',
    answer: 'Renting a 25 seater Tempo Traveller with Amruta Travels is quick and easy! You can book online through our website, call our customer service, or visit our office. We’ll help you with all the details to ensure a smooth journey.',
  },
  {
    question: 'What are the features of the 25 seater Tempo Traveller?',
    answer: 'Our 25 seater Tempo Traveller comes with push-back seats, air conditioning, ample legroom, and space for luggage. It’s ideal for group travel, family trips, corporate outings, and small events.',
  },
  {
    question: 'Is the 25 seater Tempo Traveller suitable for outstation trips?',
    answer: 'Yes, our Tempo Traveller is perfect for outstation trips from Pune. It offers a comfortable ride over long distances, with experienced drivers who are familiar with major routes and destinations.',
  },
  {
    question: 'Can I book the 25 seater for one-day or multi-day trips?',
    answer: 'Absolutely! You can rent the Tempo Traveller for both one-day local trips and multi-day tours. Just share your itinerary, and we’ll provide a suitable package based on your travel duration and needs.',
  },
  {
    question: 'Are the drivers professional and experienced?',
    answer: 'Yes, our drivers are licensed, well-trained, and courteous. They ensure a safe and smooth journey for all passengers and are knowledgeable about both city and outstation routes.',
  },
  {
    question: 'Is the vehicle cleaned and sanitized before use?',
    answer: 'Yes, we maintain high hygiene standards. All our vehicles, including the 25 seater Tempo Traveller, are thoroughly cleaned and sanitized before every trip for your safety and comfort.',
  },
  {
    question: 'What is the rental cost of a 25 seater Tempo Traveller in Pune?',
    answer: 'The rental cost depends on factors like distance, duration, and trip type (local or outstation). Contact us for a customized quote with transparent and competitive pricing.',
  },
  {
    question: 'Can I make multiple pickups or drops during the trip?',
    answer: 'Yes, we offer flexible route planning with multiple pickup and drop points. Just inform us in advance, and we’ll accommodate your route preferences wherever possible.',
  },
  {
    question: 'Do you provide Tempo Travellers for events or group functions?',
    answer: 'Yes, our 25 seater Tempo Traveller is ideal for weddings, picnics, school trips, corporate events, and more. Let us know the nature of your event for tailored arrangements.',
  },
  {
    question: 'Why choose Amruta Travels for 25 seater Tempo Traveller rental?',
    answer: 'Amruta Travels is trusted for safe, reliable, and affordable travel solutions. Our Tempo Travellers are well-maintained, our drivers are professional, and we prioritize customer satisfaction in every trip.',
  },
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Sandeep Jadhav',
    role: 'Tour Organizer, Pune',
    text: 'We booked a 25 seater Tempo Traveller from Amruta Travels for a weekend tour, and the experience was excellent. The vehicle was clean and spacious, and the driver was very cooperative. Highly recommended!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Mrs. Meenal Patankar',
    role: 'School Administrator, Pune',
    text: 'Amruta Travels provided a 25 seater Tempo Traveller for our school picnic. The service was punctual, and the journey was smooth. Parents and students were very happy with the arrangements.',
    rating: 5,
  },
];





































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/28.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/27.jpg", alt: "Image 1" },
        { src: "/images/gallery/29.jpg", alt: "Image 1" },
        { src: "/images/gallery/30.jpg", alt: "Image 1" },
        { src: "/images/gallery/31.jpg", alt: "Image 1" },

    ];





const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "25 Seater Tempo Traveller on Rent in Pune",
  "image": "https://bushireinpune.com/assets/images/25-seater-tempo-traveller.jpg",
  "description": "Rent a 25 Seater Tempo Traveller in Pune with Amruta Travels. Ideal for weddings, picnics, corporate trips, and outstation tours like Shirdi, Goa, and Bhimashankar. Choose AC or Non-AC options at affordable per km rates. Comfortable and reliable travel for groups and families.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "4216"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "28", // per km rate can be adjusted as per real price
    "availability": "https://schema.org/InStock",
    "url": "https://bushireinpune.com/25-seater-tempo-traveller-rent-pune"
  }
};





    return (
        <div>

<Helmet>
  <title>Call: +91 7353109555 | 25 Seater Tempo Traveller on Rent in Pune | AC & Non-AC | Amruta Travels</title>
  <meta 
    name="description" 
    content="Book 25 Seater Tempo Traveller on rent in Pune for weddings, trips to Shirdi, Goa, Bhimashankar, and more. AC & Non-AC options available at affordable rates with Amruta Travels." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/3.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Seatertempo;